<script setup>
import { Menu, MenuButton, MenuItem, MenuItems } from '@headlessui/vue'
import { ChevronDownIcon } from '@heroicons/vue/solid'
import { onMounted, reactive, ref } from 'vue'

const emits = defineEmits(['update-selected'])
const selected = ref(null)

const durations = reactive([
  {
    id: 1,
    label: 'Laatste 30 dagen',
    key: 'LAST_30_DAYS',
  },
  {
    id: 2,
    label: 'Laatste 90 dagen',
    key: 'LAST_90_DAYS',
  },
  {
    id: 3,
    label: 'Dit jaar',
    key: 'CURRENT_YEAR',
  },
])

const props = defineProps({
  additionalDurations: {
    type: Array,
    default: [],
  },
})

const setSelected = (duration) => {
  selected.value = duration
  emits('update-selected', duration.key)
}

onMounted(() => {
  durations.push(...props.additionalDurations)
  setSelected(durations[0])
})
</script>
<template>
  <Menu as="div" class="relative inline-block text-left">
    <div>
      <MenuButton
        class="inline-flex w-full justify-center rounded-md border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-700 shadow-sm hover:bg-gray-50 focus:outline-none"
      >
        {{ selected ? selected.label : 'Termijnen' }}
        <ChevronDownIcon class="-mr-1 ml-2 h-5 w-5" aria-hidden="true" />
      </MenuButton>
    </div>

    <transition
      enter-active-class="transition ease-out duration-100"
      enter-from-class="transform opacity-0 scale-95"
      enter-to-class="transform opacity-100 scale-100"
      leave-active-class="transition ease-in duration-75"
      leave-from-class="transform opacity-100 scale-100"
      leave-to-class="transform opacity-0 scale-95"
    >
      <MenuItems
        class="absolute right-0 mt-2 w-56 origin-top-right cursor-pointer rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none"
      >
        <div class="py-1">
          <MenuItem
            v-for="duration in durations"
            :key="duration.id"
            @click="setSelected(duration)"
            v-slot="{ active }"
          >
            <div
              :class="[
                active ? 'bg-gray-100 text-gray-900' : 'text-gray-700',
                'block px-4 py-2 text-sm',
              ]"
            >
              {{ duration.label }}
            </div>
          </MenuItem>
        </div>
      </MenuItems>
    </transition>
  </Menu>
</template>
